import { useRequestProfileDocFlowLinkActions } from '../../../RequestProfile.hooks'
import { isRequestProfileHeaderFooterDocFlowOptionConnect } from '../../RequestProfileHeaderFooter.utils'

// The "More" menu entry has no dropdown, so it falls back to create.
export function useRequestProfileCreateDocFlowAction() {
  const { handleClickConnectDocFlow, handleClickCreateDocFlow } =
    useRequestProfileDocFlowLinkActions()

  function handleSelectDocFlowOption({ value }) {
    if (isRequestProfileHeaderFooterDocFlowOptionConnect(value)) {
      handleClickConnectDocFlow()
    } else {
      handleClickCreateDocFlow()
    }
  }

  return { handleClickCreateDocFlow, handleSelectDocFlowOption }
}
